import { notification } from "antd";
import moment from "moment";
import { dietPdfApi, sendDietApi } from "../../../../../../../config/Api";
import { apiErrorMessage } from "../../../../../../../services/ApiError";

// the banner and the Assigned Diets tab reload when a diet is saved or sent anywhere on the page
export const DIET_STATUS_EVENT = 'diet-status-changed'
export const dietStatusChanged = () => window.dispatchEvent(new Event(DIET_STATUS_EVENT))

// "27-09-2026" -> "27 Sep"
export const shortDate = (date) => moment(date, 'DD-MM-YYYY').format('DD MMM')

// email the diet for these days (with the PDF) and mark them sent
export const sendDiet = (patientId, dates) =>
    sendDietApi(patientId, dates)
        .then((res) => {
            notification.success({ message: res.data.message, duration: 8 })
            dietStatusChanged()
            return true
        })
        .catch((err) => {
            notification.error({ message: apiErrorMessage(err), duration: 8 })
            return false
        })

// open the diet PDF (the one the patient gets) in a new tab; the API needs the login, so it's fetched first
export const openDietPdf = (patientId, from, to) => {
    // open the tab right away (still part of the click) so the browser doesn't block it as a pop-up
    const tab = window.open('about:blank', '_blank')
    return dietPdfApi(patientId, from, to)
        .then((res) => {
            const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
            if (tab && !tab.closed) {
                tab.location.href = url
            } else {
                // no new tab (blocked): download it instead of leaving the app
                const link = document.createElement('a')
                link.href = url
                link.download = `diet-plan-${from}-to-${to}.pdf`
                document.body.appendChild(link)
                link.click()
                link.remove()
            }
        })
        .catch((err) => {
            if (tab) tab.close()
            notification.error({ message: apiErrorMessage(err, 'Could not open the PDF.') })
        })
}
